<template>
    <div id="tab5" class="content footer">
        <div class="footer-container">
            <div class="footer-logo-container">
                <img class="footer-logo" src="@/assets/image/footer_logo.png" />
            </div>
            <div class="footer-right">
                <div class="footer-right-link">
                    <div class="icon-item" v-for="(items, index) in list" :key="index">
                        <a :href="items.linkUrl" target="_blank">
                            <el-image :src="items.linkImg" />
                            {{ items.linkName }}
                        </a>
                    </div>
                </div>
                <div class="footer-right-contact">
                    <div class="footer-right-left">
                        <div class="contact-title">联系我们</div>
                        <div class="contact-item">
                            <div class="icon-item">
                                <svg-icon iconClass="mail" />
                                {{ baseInfo.email.configContent }}
                            </div>
                            <div class="icon-item">
                                <svg-icon iconClass="phone" />
                                {{ baseInfo.phone.configContent }}
                            </div>
                        </div>
                        <div class="contact-item">
                            <div class="icon-item">
                                <svg-icon iconClass="address" />
                                {{ baseInfo.address.configContent }}
                            </div>
                        </div>
                    </div>
                    <div class="footer-right-right" v-if="join">
                        <a :href="join.linkUrl" target="_blank">
                            <img :src="join.linkImg" />
                            <div class="join-title">{{ join.linkName }}</div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-copyright">
            {{ baseInfo.copyright_information.configContent }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'Footer',
    props: {
        baseInfo: {
            type: Object,
            default: () => {},
        },
        links: {
            type: Array,
            default: () => [],
        },
    },
    watch: {
        links() {
            this.list = this.links.filter((items) => items.linkName != '加入我们')

            const [join] = this.links.filter((items) => items.linkName == '加入我们')

            this.join = join
        },
    },
    data: function () {
        return {
            list: [],
            join: null,
        }
    },
}
</script>

<style lang="scss">
.footer {
    width: 100%;
    background: #232323;
    margin-top: 60px;
    padding-top: 40px;
    box-sizing: border-box;
    .footer-container {
        width: 1600px;
        display: flex;
        border-bottom: 1px #999999 solid;
        padding-bottom: 10px;
        margin: 0 auto;
    }
    .footer-logo-container {
        width: 360px;
        height: 230px;
        border-right: 1px #999999 solid;
        padding-right: 140px;
        .footer-logo {
            width: 220px;
            height: 220px;
        }
    }
    .footer-right {
        margin-left: 80px;
        .icon-item {
            font-size: 14px;
            color: #f5f5f5;
            font-weight: 500;
            display: inline-block;
            cursor: pointer;
            .el-image {
                vertical-align: middle;
                margin-right: 10px;
            }
        }
        .icon-item + .icon-item {
            margin-left: 40px;
        }
        .svg-icon {
            margin-right: 20px;
        }
        .footer-right-link {
            border-bottom: 1px #999999 solid;
            padding-bottom: 20px;
            font-size: 14px;
            text-align: left;
        }
        .footer-right-contact {
            display: flex;
            justify-content: space-between;
            width: 1158px;
            .footer-right-left {
                text-align: left;
                .contact-title {
                    color: #f5f5f5;
                    font-size: 20px;
                    font-weight: 500;
                    margin-top: 25px;
                }
                .contact-item {
                    font-size: 14px;
                    margin-top: 40px;
                }
            }
            .footer-right-right {
                img {
                    width: 256px;
                    height: 147px;
                }
                .join-title {
                    color: #ffffff;
                    font-size: 16px;
                    font-weight: 500;
                    margin-top: 10px;
                }
            }
        }
    }
    .footer-copyright {
        color: #666666;
        font-size: 16px;
        font-weight: 500;
        margin: 0 auto;
        padding: 20px 0;
    }
}
</style>
